import { makeStyles } from '@material-ui/core'


const UnauthorizedTheme = makeStyles((theme) => ({
    Container: {
        padding: '12% 0% 0% 22.5%'
    },
    Content: {
        backgroundColor: 'white',
        width: '70%',
        padding: '50px',
    },
    ErrorContent: {
        textAlign: 'center',
        paddingTop: '5%'
    },

    ErrorDetail: {
        paddingTop: '2%',
        fontSize: '12px'
    },

    Title: {
        paddingBottom: '5%',
        textAlign: 'center',
        fontSize: '60px'
    },

    Text: {
        textAlign: 'center'
    },

    ButtonLink: {
        background: 'none',
        border: 'none',
        padding: '0',
        fontFamily: 'arial, sans-serif',
        color: '#069',
        textDecoration: 'underline',
        cursor: 'pointer'
    },

    Button: {
        backgroundColor: '#b30101',
        border: 'none',
        color: 'white',
        padding: '15px 71px',
        textAlign: 'center',
        textDecoration: 'none',
        display: 'inline-block',
        fontSize: '16px',
        margin: '4px 2px',
        cursor: 'pointer',
        marginTop: '20px',
        marginLeft: '35%',
        
        '&:hover': {
            cursor: 'pointer',
            backgroundColor: '#b30101c4',
            color: '#fff',
            transition: 'all 0.2s ease',
        }
    }
}));

export default UnauthorizedTheme;